/* eslint-disable react/jsx-indent */
/* eslint-disable react/function-component-definition */
import React from "react";
import {
  Box,
  CardActionArea,
  Typography,
  Link,
  CardMedia,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { getTemplatesServerType } from "../constants";

type InfoLineProps = {
  leftTxt?: string;
  rightTxt?: string;
  result?: string;
  file?: string;
  originalPath?: string;
  imgPath?: string;
  videoPath?: string;
  descHeight?: string;
  ratio1?: string;
  ratio2?: string;
  copy?: boolean;
  opt?: boolean;
  templatesLink?: string;
  jiraTicket?: boolean;
  // rightTxt 대신 임의의 노드를 우측에 렌더한다. (태그 목록 등)
  rightNode?: React.ReactNode;
};

export default function InfoLine({
  leftTxt,
  rightTxt,
  rightNode,
  result,
  file,
  originalPath,
  imgPath,
  videoPath,
  descHeight,
  ratio1,
  ratio2,
  copy,
  opt,
  templatesLink,
  jiraTicket,
}: InfoLineProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        m: "10px",
        mb: "-10px",
      }}
      minHeight={35}
    >
      {result === "pass" ? (
        <DoneIcon sx={{ color: "green", mr: "8px" }} />
      ) : result === "reject" ? (
        <CloseIcon sx={{ color: "red", mr: "8px" }} />
      ) : (
        <Box sx={{ width: "24px", mr: "8px" }} />
      )}
      <Box width={"30%"}>
        <Typography fontWeight={500}>{leftTxt}</Typography>
      </Box>

      {rightNode ? (
        <Box minWidth={"20%"} maxWidth={650}>
          {rightNode}
        </Box>
      ) : (
        <Box>
          <Typography
            minWidth={"20%"}
            maxWidth={650}
            sx={{ mt: opt || videoPath ? "-35px" : "" }}
          >
            {!file &&
              !videoPath &&
              !imgPath &&
              (templatesLink && templatesLink !== "" ? (
                <Link
                  href={getTemplatesServerType() + "templates/" + templatesLink}
                >
                  {rightTxt + " "}
                </Link>
              ) : (
                rightTxt + " "
              ))}
            {copy && (
              <ContentCopyIcon
                sx={{ fontSize: "large", cursor: "pointer", color: "6666ff" }}
                onClick={() => {
                  rightTxt && navigator.clipboard.writeText(rightTxt);
                }}
              />
            )}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
